/**
 * All global constants can be defined here
 * @author Manne Hareesh
 */

import { checkActionAllowed, isValid, isValidArray } from "./utilities";

// Static Messages
export const FAILURE_STATUS = "FAILURE";
export const SUCCESS_STATUS = "SUCCESS";

export const PRE_PAID_USER ="Prepaid";
export const POST_PAID_USER ="Postpaid";

export const PRIVILEGE_MASTER = "Master User";
export const PRIVILEGE_REPORTS = "Reports";
export const PRIVILEGE_HEAD_OFFICE = "Head Office";

export const DAFIDY_USER = "Dafidy user";
export const DAFIDY_OPERATOR_CODE = "DAFIDY";
export const QB_USER = "QB";
export const OTA_USER = "OTA";
export const PREPAID_OTA_USER = "Prepaid-OTA";

export const AGENT_TRANSACTION_PENDING = 'Pending';
export const AGENT_TRANSACTION_COMPLETED = 'Completed';
export const AGENT_TRANSACTION_FAILED = 'Failed';

export const MIN_DURATION_TO_AUTO_CREATE_ROUTE = 120;   // IST offset UTC +5:30
export const PER_DAY_MINS = 1440;

export const showUpdatebtn=()=>{
    if(checkActionAllowed(AGENT_TO_VIEW_NEW_TIMING_TAB)){
        return true;
    }else{
        return false;
    }
}

export const dafidyUserCheck=()=>{
    if(global.privilege === DAFIDY_USER){
        return true;
    }else{
        return false;
    }
}

/*
  Agents under the DAFIDY operator sell every operator's trips, so a trip from a
  different operator is a normal booking for them, not a shared service.
*/
export const isMultiOperatorAgentCheck=()=>{
    if(global.isMultiOperatorAgent){
        return true;
    }else{
        return false;
    }
}

/*
  A trip owned by another operator is a shared service only for single operator
  agents. Multi operator agents sell every operator, so such a trip is a normal
  booking for them and must follow the logged in agent's own permissions.
*/
export const isSharedTripCheck=(operatorCode)=>{
    if(isMultiOperatorAgentCheck()){
        return false;
    }
    return isValid(operatorCode)&&operatorCode != global.operatorCode;
}

/*
  Ticket level counterpart of isSharedTripCheck - ticket flows only carry the
  owner travels_id, not the operator code.
*/
export const isSharedTicketCheck=(travelsId)=>{
    if(isMultiOperatorAgentCheck()){
        return false;
    }
    return isValid(travelsId)&&isValid(global.travelsId)&&travelsId != global.travelsId;
}

export const isQBUserCheck=()=>{
    if(global.privilege === QB_USER){
        return true;
    }else{
        return false;
    }
}

export const isOTAUser = () => {
    if(global.privilege === OTA_USER){
        return true;
    }else{
        return false;
    }
}


export const removeHttp = (url)=> {
    if(isValid(url)){
        url = url.replace(/www./, '');
        return url.replace(/^https?:\/\//, '');
    }else{
        return '';
    }
}

export const getWebSiteUrlForStorage = () => {
    const url = removeHttp(global.webSiteUrl);
    return url ? url.replace(/\/+$/, '') : '';
}

export const getAdminUrl=()=>{
    if(isValid(global.adminClientUrl)){
        return global.adminClientUrl;
    }else{
        let webSiteUrl = removeHttp(global.webSiteUrl);
        return `https://admin.${webSiteUrl}`;
    }
}

// Add style object for logo image
export const logoStyle = {
    width: 'auto',
    height: '50px',
    maxWidth: '150px',
    objectFit: 'contain'
};

export const logoLoginStyle = {
    width: 'auto',
    height: '100px',
    maxWidth: '300px',
    objectFit: 'contain'
};

//Constants for notification messages
 
export const NOTIFICATION_CANCEL_SMS_MESSAGE = `Dear Customer,Due to unforeseen reasons,your bus on $date has been cancelled.We apologize for the inconvenience-$operator_name`;
export const NOTIFICATION_CANCEL_EMAIL_MESSAGE = `Dear Customer,Thank you so much for choosing $operator_name. Due to some unforseen reasons, the bus that you were scheduled to travel on $date from $origin to $destination has been cancelled. We sincerely apologize for the inconvenience. We will try our very best to avoid such misfortunes in the future.Thank you so much for your understanding,-$operator_name`
export const NOTIFICATION_DELAY_SMS_MESSAGE = `Dear Customer,Due to unforeseen reasons,your bus on $date has been delayed by $delaytime mins.We apologize for the inconvenience-$operator_name`;
export const NOTIFICATION_DELAY_EMAIL_MESSAGE = `Dear Customer,Thank you so much for choosing $operator_name. Due to some unforseen reasons, the bus that you were scheduled to travel on $date from $origin to $destination has been delayed by $delaytime mins. We sincerely apologize for the inconvenience. We will try our very best to avoid such misfortunes in the future.Thank you so much for your understanding,- $operator_name`;
 
//TIME ZONE
export const IST_OFFSET = 330;
 
//Data types for data table component
export const DSTRING = "string";
export const DNUMBER = "number";
export const DDATE = "date";
export const DDATETIME = "datetime";
export const DCOMPONENT = "component";

export const RED_BUS_USER_NAME = "redbus";
export const ABHI_BUS_USER_NAME = "abhibus";
export const PAYTM_BUS_USER_NAME = "paytm";
 
//Allowed actions for user
export const SHOW_AGENT_DASHBOARD = "SHOW_AGENT_DASHBOARD";
export const ACTION_VIEW_SEARCH_PAGE_ALLOWED = "SEARCH_PAGE_ALLOWED";//done
export const ACTION_VIEW_REPORTS_PAGE_ALLOWED = "REPORTS_PAGE_ALLOWED";//done
export const ACTION_TO_VIEW_TRIP_SHEET_PERMISSION_PAGE = "ACTION_TO_VIEW_TRIP_SHEET_PERMISSION_PAGE";
export const ACTION_VIEW_CANCEL_PAGE_ALLOWED = "VIEW_CANCEL_PAGE_ALLOWED";//done
export const ACTION_VIEW_NOTIFICATION_PAGE_ALLOWED = "NOTIFICATION_PAGE_ALLOWED";//done
export const ACTION_VIEW_BUS_CANCELLATION_PAGE_ALLOWED = "BUS_CANCELLATION_PAGE_ALLOWED";//done
export const ACTION_VIEW_STAFF_PAGE_ALLOWED = "ACTION_VIEW_STAFF_PAGE_ALLOWED";//done
export const ACTION_VIEW_AGENTS_PAGE_ALLOWED = "AGENTS_PAGE_ALLOWED";//done
export const ACTION_VIEW_AGENTS_TRANSACTION_PAGE_ALLOWED = "AGENTS_TRANSACTION_PAGE_ALLOWED";//done
export const ACTION_SEND_OTA_EMAILS = "ACTION_SEND_OTA_EMAILS";//done

//Allowed actions
export const ACTION_BOOK_TICKET_ALLOWED = "BOOK_TICKET_ALLOWED";//done
export const ACTION_BOOK_AVAILABLE_TICKET_ALLOWED = "BOOK_AVAILABLE_TICKET_ALLOWED";
export const ACTION_BOOK_BBA_TICKET_ALLOWED = "BOOK_BBA_TICKET_ALLOWED";//Blocked By Admin//done
export const ACTION_BOOK_BBO_TICKET_ALLOWED = "BOOK_BBO_TICKET_ALLOWED";//Blocked By Other//done
export const ACTION_BOOK_BBS_TICKET_ALLOWED = "BOOK_BBS_TICKET_ALLOWED";//Blocked By Self//done(not required)
 
export const ACTION_BLOCK_TICKET_ALLOWED = "BLOCK_TICKET_ALLOWED";//done
export const ACTION_PHONE_BLOCK_ALLOWED = "ACTION_PHONE_BLOCK_ALLOWED";//done
export const ACTION_UPI_BOOKING = "ACTION_UPI_BOOKING";// Razorpay partner-model UPI booking (no PG redirect)
export const ACTION_RELEASE_TICKET_ALLOWED = "RELEASE_TICKET_ALLOWED";//done
export const ACTION_RELEASE_OTA_TICKETS_ALLOWED = "RELEASE_OTA_TICKETS_ALLOWED";//done
export const ACTION_RELEASE_BBO_TICKET_ALLOWED = "RELEASE_BBO_TICKET_ALLOWED";//not required
export const ACTION_RELEASE_BBA_TICKET_ALLOWED = "RELEASE_BBA_TICKET_ALLOWED";//not required
export const ACTION_RELEASE_BBS_TICKET_ALLOWED = "RELEASE_BBS_TICKET_ALLOWED";//not required
export const ACTION_SEAT_GENDER_UPDATE_ALLOWED = "SEAT_GENDER_UPDATE_ALLOWED";//done
export const ACTION_CANCEL_TICKET_ALLOWED = "CANCEL_TICKET_ALLOWED";//done
export const ACTION_CANCEL_BKBO_TICKET_ALLOWED = "CANCEL_BKBO_TICKET_ALLOWED";
export const ACTION_CANCEL_BKBS_TICKET_ALLOWED = "CANCEL_BKBS_TICKET_ALLOWED";
export const ACTION_BLOCK_ALL_TICKETS_ALLOWED = "BLOCK_ALL_TICKETS_ALLOWED";//done
export const ACTION_SEAT_NUMBER_UPDATE_ALLOWED = "SEAT_NUMBER_UPDATE_ALLOWED";//done
export const ACTION_TO_UPDATE_AGENT_IN_TICKET = "ACTION_TO_UPDATE_AGENT_IN_TICKET";
export const ACTION_TO_VIEW_SET_GENDER_BTN = "ACTION_TO_VIEW_SET_GENDER_BTN";//done
export const ACTION_UPDATE_TICKET_REMARKS = "ACTION_UPDATE_TICKET_REMARKS";
export const ACTION_UPDATE_TICKET_POPUP_UPDATE_BTN = "ACTION_UPDATE_TICKET_POPUP_UPDATE_BTN";
export const ACTION_TICKET_NOTIFY_BTN = "ACTION_TICKET_NOTIFY_BTN";
export const ACTION_AGENT_REFUND_TICKET = "ACTION_AGENT_REFUND_TICKET";
export const ACTION_CONFIRM_PG_TICKET = "ACTION_CONFIRM_PG_TICKET";
export const VIEW_CONFIG_EXPENSES_PAGE = "VIEW_CONFIG_EXPENSES_PAGE";

//Cancellation related actionss
export const ACTION_SEND_CANCEL_NOTIFICATION_ALLOWED = "SEND_CANCEL_NOTIFICATION_ALLOWED";//done
export const ACTION_OVERRIDE_CANCELLATION_PENALTY_ALLOWED = "OVERRIDE_CANCELLATION_PENALTY_ALLOWED";//done

// Allowed reports for user
export const ACTION_VIEW_BLOCKED_TICKETS_REPORT_ALLOWED = "BLOCKED_TICKETS_REPORT_ALLOWED";
export const ACTION_VIEW_BOOKED_TICKETS_REPORT_ALLOWED = "BOOKED_TICKETS_REPORT_ALLOWED";//done
export const ACTION_VIEW_TICKET_SHARING_REPORT_ALLOWED = "TICKET_SHARING_REPORT_ALLOWED";//done
export const ACTION_VIEW_SETTLEMENT_REPORT_ALLOWED = "SETTLEMENT_REPORT_ALLOWED";//done
export const ACTION_VIEW_CURRENT_INFO_REPORT_ALLOWED = "CURRENT_INFO_REPORT_ALLOWED";
export const ACTION_VIEW_MASTER_TRIP_REPORT_ALLOWED = "MASTER_TRIP_REPORT_ALLOWED";//done
export const ACTION_VIEW_GROUP_BY_BRANCH_REPORT_ALLOWED = "GROUP_BY_BRANCH_REPORT";
export const ACTION_VIEW_PASSENGER_INFO_REPORT_ALLOWED = "PASSENGER_INFO_REPORT_ALLOWED";//done
export const ACTION_VIEW_PERFORMANCE_REPORT_ALLOWED = "PERFORMANCE_REPORT_ALLOWED";
export const ACTION_VIEW_REVENUE_REPORT_ALLOWED = "ACTION_TO_VIEW_REVENUE_REPORT";
export const ACTION_TO_VIEW_MAVEN_TRANSACTION_REPORT="ACTION_TO_VIEW_MAVEN_TRANSACTION_REPORT";

export const ACTION_VIEW_SALES_REPORT_ALLOWED = "SALES_REPORT_ALLOWED";//done
export const ACTION_VIEW_MASTER_AGENT_SALES_REPORT_ALLOWED = "VIEW_MASTER_AGENT_SALES_REPORT";
export const ACTION_VIEW_EXPENSE_REPORT_ALLOWED = "EXPENSE_REPORT_ALLOWED";
export const ACTION_VIEW_TICKET_SEARCH_REPORT_ALLOWED = "TICKET_SEARCH_REPORT_ALLOWED";//done
export const ACTION_VIEW_TICKET_SEARCH_REPORT_OLD_ALLOWED = "TICKET_SEARCH_REPORT_OLD_ALLOWED";//done
export const ACTION_VIEW_TOTAL_TRANSACTION_REPORT_ALLOWED = "TOTAL_TRANSACTION_REPORT_ALLOWED";
export const ACTION_VIEW_TRIP_REPORT_ALLOWED = "TRIP_REPORT_ALLOWED";//done
export const MINI_TRIP_SHEET_ALLOWED = "MINI_TRIP_SHEET_ALLOWED";
export const ACTION_VIEW_WEB_TICKET_CANCELLATION_REPORT_ALLOWED = "WEB_TICKET_CANCELLATION_REPORT_ALLOWED";
export const ACTION_VIEW_WEB_TICKET_SALES_REPORT_ALLOWED = "WEB_TICKET_SALES_REPORT_ALLOWED";
export const ACTION_VIEW_ABANDONED_REPORT_ALLOWED = "ABANDONED_REPORT_ALLOWED";
export const ACTION_VIEW_TICKETS_BOOKED_AFTER_START_TIME_ALLOWED = "ACTION_VIEW_TICKETS_BOOKED_AFTER_START_TIME_ALLOWED";
export const ACTION_VIEW_ANALYTICS_DEMAND = "ACTION_VIEW_ANALYTICS_DEMAND";
export const ACTION_TO_VIEW_ACTIVE_BOOKINGS_REPORT = "ACTION_TO_VIEW_ACTIVE_BOOKINGS_REPORT";
export const ACTION_TO_VIEW_SERVICE_COUNT_REPORT = "ACTION_TO_VIEW_SERVICE_COUNT_REPORT";
export const ACTION_VIEW_RESCHEDULED_REPORT_PAGE = "VIEW_RESCHEDULED_REPORT_PAGE";
export const ACTION_TO_VIEW_OPERATOR_COST_SUMMARY = "ACTION_TO_VIEW_OPERATOR_COST_SUMMARY";
export const ACTION_VIEW_SETTLEMENT_ADMIN = "VIEW_SETTLEMENT_ADMIN";
export const ACTION_VIEW_OWN_SETTLEMENT = "VIEW_OWN_SETTLEMENT";
export const ACTION_GENERATE_SETTLEMENT_DRAFT = "GENERATE_SETTLEMENT_DRAFT";
export const ACTION_EDIT_SETTLEMENT = "EDIT_SETTLEMENT";
export const ACTION_APPROVE_SETTLEMENT = "APPROVE_SETTLEMENT";
export const ACTION_CANCEL_SETTLEMENT = "CANCEL_SETTLEMENT";
export const ACTION_RECORD_SETTLEMENT_PAYMENT = "RECORD_SETTLEMENT_PAYMENT";
export const ACTION_MODIFY_SETTLEMENT_PAYMENT = "MODIFY_SETTLEMENT_PAYMENT";
export const ACTION_SET_SETTLEMENT_OPENING_BALANCE = "SET_SETTLEMENT_OPENING_BALANCE";
export const ACTION_TO_VIEW_OPERATOR_TRANSACT_SUMMARY = "ACTION_TO_VIEW_OPERATOR_TRANSACT_SUMMARY";
export const ACTION_TO_VIEW_OPERATOR_TRACKING_SUMMARY = "ACTION_TO_VIEW_OPERATOR_TRACKING_SUMMARY";
export const ALLOW_VERIFY_ADDRESS = "ALLOW_VERIFY_ADDRESS";

export const ACTION_BLOCK_BY_ADMIN_SEATS_ALLOWED = "ACTION_BLOCK_BY_ADMIN_SEATS_ALLOWED";
export const ACTION_PERMANENT_ADMIN_BLOCK = "ACTION_PERMANENT_ADMIN_BLOCK";
export const ACTION_PERMANENT_ADMIN_BLOCK_RELEASE = "ACTION_PERMANENT_ADMIN_BLOCK_RELEASE";
export const MARK_LAST_ROW_AS_MALE_RESERVED = "MARK_LAST_ROW_AS_MALE_RESERVED";
export const ACTION_GENERATE_PAYMENT_LINK_ALLOWED = "ACTION_GENERATE_PAYMENT_LINK_ALLOWED";
export const ACTION_CHANGE_BUS_ALLOWED = "ACTION_CHANGE_BUS_ALLOWED";

export const ACTION_SMS_REPORT_ALLOWED = "ACTION_SMS_REPORT_ALLOWED";

export const ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL = "ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL_ALLOWED";
export const UPDATE_DP_FOR_TRIP = "UPDATE_DP_FOR_TRIP";
export const ACTION_TO_EDIT_VECHICLE_INFO_FROM_AGENT_PORTAL = "ACTION_TO_EDIT_VECHICLE_INFO_FROM_AGENT_PORTAL_ALLOWED";
export const ACTION_TO_VIEW_VEHICLE_INFO = "ACTION_TO_VIEW_VEHICLE_INFO";
export const UPDATE_DAY_SPECIFIC_ROUTE_TIMING = 'UPDATE_DAY_SPECIFIC_ROUTE_TIMING';
export const UPDATE_IN_NEW_TIME_TAB ='UPDATE_IN_NEW_TIME_TAB';

export const ACTION_TO_VIEW_SEAT_DOUBLE_CLICK="ACTION_TO_VIEW_SEAT_DOUBLE_CLICK";
export const SHOW_CLIENT_SIDE_DISCOUNT="SHOW_CLIENT_SIDE_DISCOUNT";
export const SHOW_MAX_DISCOUNT="SHOW_MAX_DISCOUNT";
export const SHOW_MIN_AND_MAX_FARE_FOR_SERVER_DISCOUNT="SHOW_MIN_AND_MAX_FARE_FOR_SERVER_DISCOUNT";

export const TRIP_EXPENSE_PAGE = "TRIP_EXPENSE_PAGE";
export const VIEW_AGENT_TRIP_CREATE = "VIEW_AGENT_TRIP_CREATE";

export const ACTION_TO_VIEW_NOT_BOARDED_BUTTON ='ACTION_TO_VIEW_NOT_BOARDED_BUTTON';

export const VIEW_PREPAID_AGENT_ACCOUNT_DATA = "VIEW_PREPAID_AGENT_ACCOUNT_DATA";
export const SERVICE_ACCESS_PAGE_ALLOWED = "SERVICE_ACCESS";
export const MANAGE_SERVICE_SHARING = "MANAGE_SERVICE_SHARING";
export const MANAGE_BOOKING_PARTNERS = "MANAGE_BOOKING_PARTNERS";
export const ACTION_VIEW_SHARED_TRIP_SALES_REPORT_ALLOWED = "SHARED_TRIP_SALES_REPORT_ALLOWED";
export const ACTION_EXCEPTIONAL_REFUND_ALLOWED = "ACTION_EXCEPTIONAL_REFUND_ALLOWED";

//Admin Pages
export const ADMIN_VIEW_AGENTS_PAGE="ADMIN_VIEW_AGENTS_PAGE";
export const AGENT_VIEW_STANDARD_STOPS_PAGE="AGENT_VIEW_STANDARD_STOPS_PAGE";
export const ADMIN_VIEW_TRIPS_PAGE="ADMIN_VIEW_TRIPS_PAGE";
export const ADMIN_VIEW_BULK_TRIP_VEHICLE_UPDATE_PAGE="ADMIN_VIEW_BULK_TRIP_VEHICLE_UPDATE_PAGE";
export const PRIORITY_ROUTES_PAGE_ALLOWED = "PRIORITY_ROUTES_PAGE_ALLOWED";
export const USER_ACTION_PAGE_ALLOWED = "USER_ACTION_PAGE_ALLOWED";
export const ADMIN_VIEW_VEHICLE_MANAGEMENT_PAGE = "ADMIN_VIEW_VEHICLE_MANAGEMENT_PAGE";
export const SHOW_OPERATOR_CONFIG_PAGE = "SHOW_OPERATOR_CONFIG_PAGE";
export const VIEW_BOOKING_CONFIG = "VIEW_BOOKING_CONFIG";
export const VIEW_BILLING_CONFIG = "VIEW_BILLING_CONFIG";
export const SHOW_COLOUR_CONFIG_PAGE = "SHOW_COLOUR_CONFIG_PAGE";
export const SHOW_BUS_OPERATOR_PAGE_FOR_BDM = "SHOW_BUS_OPERATOR_PAGE_FOR_BDM";
export const ADMIN_CHANGE_SEAT_LAYOUT = "ADMIN_CHANGE_SEAT_LAYOUT";

export const ADMIN_VIEW_CITIES_PAGE = "ADMIN_VIEW_CITIES_PAGE";
// Schedule page
export const ADMIN_VIEW_SCHEDULES_PAGE="ADMIN_VIEW_SCHEDULES_PAGE";
export const AGENT_TO_VIEW_PASSENGER_TAB="AGENT_TO_VIEW_PASSENGER_TAB";
export const AGENT_TO_VIEW_NEW_TIMING_TAB="AGENT_TO_VIEW_NEW_TIMING_TAB";
export const AGENT_TO_VIEW_LOGS_TAB = "AGENT_TO_VIEW_LOGS_TAB";
export const VIEW_ADMIN_TAB_IN_SEARCH_PAGE ="VIEW_ADMIN_TAB_IN_SEARCH_PAGE";
export const MANAGE_CITIES_IN_SEARCH_PAGE ="MANAGE_CITIES_IN_SEARCH_PAGE";
export const ADMIN_ACTION_TRIP_DETAILS_VIEW = "ADMIN_ACTION_TRIP_DETAILS_VIEW";

export const SHOW_REVENUE_IN_AGENT_CLIENT = "SHOW_REVENUE_IN_AGENT_CLIENT";

//SERVICE WORKER NOTIFICATION ID
export const SERVICE_WORKER_NOTIFICATION = "SWR_NOTIFICATION";
export const SERVICE_WORKER_UPDATE_TIME_INTERVAL = 1000 * 60 * 60;
 
export const AGENT_EMAIL_MESSAGE = 'We had cancelled the following services. Please issue a full refund ONLY to the PNRs mentioned below. The other seats in the buses have been re-assigned to a different service after communicating with the customers:'

export const LOGIN_ACCESS_TOKEN_KEY = "shbdhbhbdshbknanaknjknakjbkbfjhsbhjbmdandk";
export const AGENT_COLORS_ACCESS_TOKEN_KEY = "djnjfndbfkhlbhdsbfhbdshfbhdabcdcd";
export const SERVER_URL_ACCESS_TOKEN_KEY = "serverUrlTokenKeyfetchingdata";
export const LOGIN_USER_NAME_KEY = "loginUserNameKeyfetchingdata";
export const GOOGLE_MAPS_API = "AIzaSyDrk4VeM3JL3wDvOXfOVzQbTSNm7GITmT8";

export const SESSION_TIME_OUT_MINS = 60;
export const TIME_STAMP_FOR_ACTIVE_BOOKINGS = 60;

export const STAFF_DRIVER = "Driver";
export const STAFF_CONDUCTOR = "Conductor";

//Logs Table Action
export const LOGS_CUSTOMER_DATA = "Customer Data/Seat Number Updated";
export const LOGS_EDIT_FARE = "Edit Fare";
export const LOGS_SEAT_FARE = "Seat Fare";
export const LOGS_PICK_UP_TIMINGS = "Pickup Points Changed";
export const LOGS_DROP_TIMINGS = "Drop Points Changed";
export const LOGS_FOR_RELEASE_SEATS ="Release Seats";
export const LOGS_FOR_ADMIN_BLOCK_SEATS ="Admin Block Seats";
export const LOGS_FOR_DRIVER_PH_NO_UPDATE ="Driver Phone Number Update";
export const LOGS_FOR_VECHICLE_UPDATE ="Vechicle Update";
export const LOGS_TRACKING_SMS_SENT = "Tracking SMS Sent";
export const LOGS_MANAGEMENT_ALERT_SMS = "Management Alert";
export const LOGS_BUS_CHANGE = "Bus Changed";
export const LOGS_FOR_EXCEPTIONAL_REFUND = "Exceptional Refunds";

export const ACTION_TO_VIEW_OVER_DUE_MSG="ACTION_TO_VIEW_OVER_DUE_MSG";
export const ACTION_TO_SET_DRIVER_APP_SUBSCRIPTION = "ACTION_TO_SET_DRIVER_APP_SUBSCRIPTION";

export const ACTION_TO_SET_TRIPS_CREATED="ACTION_TO_SET_TRIPS_CREATED";

export const getSameUser =(agentId)=>{
    if(agentId === global.agentId || (isValidArray(agentId)&&agentId.indexOf(global.agentId) != -1)){
        return true;
    }else{
        return false;
    }
}

export const ADMIN_VIEW_TEMPORARY_CHANGES_PAGE = "VIEW_TEMPORARY_CHANGES_PAGE";
export const ADMIN_VIEW_BUS_PAGE = "ADMIN_VIEW_BUS_PAGE";
export const AGENT_MODIFY_CANCELLATION_POLICY = "AGENT_MODIFY_CANCELLATION_POLICY";
export const ACTION_VIEW_SYSTEM_INFO_PAGE = "ACTION_VIEW_SYSTEM_INFO_PAGE";
// Metadata (Admin)
export const ADMIN_VIEW_METADATA_PAGE = "ADMIN_VIEW_METADATA_PAGE";
//Trip SHEET related permissions
export const TRIP_SHEET_HIDE_PNR = "TRIP_SHEET_HIDE_PNR";
export const TRIP_SHEET_HIDE_BOOKING_TIME = "TRIP_SHEET_HIDE_BOOKING_TIME";
export const TRIP_SHEET_HIDE_NAME = "TRIP_SHEET_HIDE_NAME";
export const TRIP_SHEET_HIDE_AGE = "TRIP_SHEET_HIDE_AGE";
export const TRIP_SHEET_HIDE_PHONE = "TRIP_SHEET_HIDE_PHONE";
export const TRIP_SHEET_HIDE_AGENT_NAME = "TRIP_SHEET_HIDE_AGENT_NAME";
export const TRIP_SHEET_HIDE_SEAT_NUM = "TRIP_SHEET_HIDE_SEAT_NUM";
export const TRIP_SHEET_HIDE_AMOUNT = "TRIP_SHEET_HIDE_AMOUNT";
export const TRIP_SHEET_HIDE_GST = "TRIP_SHEET_HIDE_GST";
export const TRIP_SHEET_HIDE_COMMISSION = "TRIP_SHEET_HIDE_COMMISSION";
export const TRIP_SHEET_HIDE_AVAILABLE_SEATS = "TRIP_SHEET_HIDE_AVAILABLE_SEATS";
export const TRIP_SHEET_HIDE_DROP_CITY = "TRIP_SHEET_HIDE_DROP_CITY";
export const TRIP_SHEET_HIDE_DROP_LOCATION = "TRIP_SHEET_HIDE_DROP_LOCATION";
export const TRIP_SHEET_HIDE_PICKUP_LOCATION = "TRIP_SHEET_HIDE_PICKUP_LOCATION";
export const TRIP_SHEET_HIDE_CANCELLED_SEATS = "TRIP_SHEET_HIDE_CANCELLED_SEATS";
export const TRIP_SHEET_HIDE_CANCELLATION_PENALTY = "TRIP_SHEET_HIDE_CANCELLATION_PENALTY";
export const TRIP_SHEET_SHOW_AVAILABLE_SEATS_ONLY = "TRIP_SHEET_SHOW_AVAILABLE_SEATS_ONLY";
export const TOOLTIP_HIDE_BOOK_INFO_OTHER_USER = "TOOLTIP_HIDE_BOOK_INFO_OTHER_USER";

export const ACTION_CREATE_TRIP_FROM_EXCEL = "ACTION_CREATE_TRIP_FROM_EXCEL";
export const AGENT_VIEW_OTA_SEARCH_PAGE_ALLOWED = "AGENT_VIEW_OTA_SEARCH_PAGE_ALLOWED";
export const ACTION_VIEW_DRIVER_ATTENDANCE_REPORT_ALLOWED = "DRIVER_ATTENDANCE_REPORT_ALLOWED";
export const ACTION_VIEW_OCCUPANCY_REPORT_ALLOWED = "OCCUPANCY_REPORT_ALLOWED";
export const ACTION_VIEW_BUS_SERVICE_COLLECTION_REPORT_ALLOWED = "BUS_SERVICE_COLLECTION_REPORT_ALLOWED";
export const ACTION_STOP_ANALYSIS_REPORT = "ACTION_STOP_ANALYSIS_REPORT";
export const ACTION_EXPORT_SCHEDULE_EXCEL = "ACTION_EXPORT_SCHEDULE_EXCEL";
export const ACTION_VIEW_SCHEDULE_COMMISSION_TAB = "ACTION_VIEW_SCHEDULE_COMMISSION_TAB";

export const AGENT_VIEW_OPERATOR_WEBSITES_MODIFY_ALLOWED = "AGENT_VIEW_OPERATOR_WEBSITES_MODIFY_ALLOWED";

export const gstRestrictedAgentPrivileges = ['OTA', 'Prepaid-OTA', 'apiAgentsInfo','prepaidOTAInfo'];
// Dynamic pricing providers - must match travels_details.dynamic_pricing_provider
export const REDBUS_DP_PROVIDER = "Redbus";
export const SCIATIVE_DP_PROVIDER = "Sciative";
